export const DATA_NOTIFICATION_SELECT_TRI_DATE = [
    {
        key: '1',
        value: 'antechronologique',
        libelle: 'Du plus récent au plus ancien',
        selected: true,
        disabled: false,
        hidden: false,
    },
    {
        key: '2',
        value: 'chronologique',
        libelle: 'Du plus ancien au plus récent',
        selected: false,
        disabled: false,
        hidden: false,
    },
];

export const DATA_NOTIFICATION_SELECT_FILTRE = [
    {
        key: '1',
        value: 'aucun',
        libelle: 'Aucun',
        selected: true,
        disabled: false,
        hidden: false,
    },
    {
        key: '2',
        value: 'autorisation',
        libelle: 'Autorisation',
        selected: false,
        disabled: false,
        hidden: false,
    },
    {
        key: '3',
        value: 'gestion',
        libelle: 'Gestion de compte',
        selected: false,
        disabled: false,
        hidden: false,
    },
    {
        key: '4',
        value: 'detention',
        libelle: 'Détention et démarches',
        selected: false,
        disabled: false,
        hidden: false,
    },
    {
        key: '5',
        value: 'ratelier',
        libelle: 'Râtelier',
        selected: false,
        disabled: false,
        hidden: false,
    },
    {
        key: '6',
        value: 'titre_de_detention_demarche',
        libelle: 'Titre de détention/démarche',
        selected: false,
        disabled: false,
        hidden: false,
    },
    {
        key: '7',
        value: 'expiration_titre_detention',
        libelle: 'Fin de validité de votre autorisation',
        selected: false,
        disabled: false,
        hidden: false,
    },
    {
        key: '8',
        value: 'quota',
        libelle: 'Quota',
        selected: false,
        disabled: false,
        hidden: false,
    },
    {
        key: '9',
        value: 'arme_interdite_acquisition_detention',
        libelle: 'Arme interdite d’acquisition et de détention présente dans votre râtelier',
        selected: false,
        disabled: false,
        hidden: false,
    },
];

export const getLibelleFiltreByValue = (value) => {
    const listeFiltree = DATA_NOTIFICATION_SELECT_FILTRE.filter(
        (element) => element.value === value,
    );
    if (!listeFiltree.length) {
        return null;
    }

    return listeFiltree[0].libelle;
};
